import { useNavigate } from 'react-router-dom';
import { ForgotPasswordForm } from '../components/ForgotPasswordForm';
import { AuthLayout } from '../components/AuthLayout';

export function ForgotPasswordPage() {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/login');
  };

  return (
    <AuthLayout title="Reset your password" description="Enter your email address and we'll send you a password reset link">
      <ForgotPasswordForm onBack={handleBack} />
    </AuthLayout>
  );
}